import { ApplicationConfig } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { DownloadOutline, PlusOutline, SearchOutline } from '@ant-design/icons-angular/icons';
import { appRoutes } from './app.routes';
import { coreConfig } from './core/core.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    // withInterceptorsFromDi() is required for the class-based HTTP_INTERCEPTORS
    // (AuthInterceptor, LoadingInterceptor) registered in core.config.ts to run.
    provideHttpClient(withInterceptorsFromDi()),
    provideNzIcons([DownloadOutline, PlusOutline, SearchOutline]),
    ...coreConfig.providers,
  ]
};

